module.exports = __webpack_public_path__ + "assets/e254f885440a9d4dbe7eb195f1d52251-DSC_0821.jpg";